// extracted by mini-css-extract-plugin
export default {"iframe":"reg_iframe__IvNAO","recimg":"reg_recimg__cjmZK","formHeader":"reg_formHeader__QbAD0","nagpurhead":"reg_nagpurhead__BbnlF"};